/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Suspend_StorefrontInputs */

const en_suspend_storefront = /** @type {(inputs: Suspend_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suspend Storefront`)
};

const id_suspend_storefront = /** @type {(inputs: Suspend_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tangguhkan Etalase`)
};

/** @type {(inputs: Suspend_StorefrontInputs) => LocalizedString} */
const es_suspend_storefront = en_suspend_storefront;

/** @type {(inputs: Suspend_StorefrontInputs) => LocalizedString} */
const fr_suspend_storefront = en_suspend_storefront;

/** @type {(inputs: Suspend_StorefrontInputs) => LocalizedString} */
const de_suspend_storefront = en_suspend_storefront;

/** @type {(inputs: Suspend_StorefrontInputs) => LocalizedString} */
const ja_suspend_storefront = en_suspend_storefront;

/** @type {(inputs: Suspend_StorefrontInputs) => LocalizedString} */
const zh_suspend_storefront = en_suspend_storefront;

/** @type {(inputs: Suspend_StorefrontInputs) => LocalizedString} */
const ar_suspend_storefront = en_suspend_storefront;

/** @type {(inputs: Suspend_StorefrontInputs) => LocalizedString} */
const it_suspend_storefront = en_suspend_storefront;

/** @type {(inputs: Suspend_StorefrontInputs) => LocalizedString} */
const ru_suspend_storefront = en_suspend_storefront;

/** @type {(inputs: Suspend_StorefrontInputs) => LocalizedString} */
const pt_suspend_storefront = en_suspend_storefront;

/** @type {(inputs: Suspend_StorefrontInputs) => LocalizedString} */
const ko_suspend_storefront = en_suspend_storefront;

/**
* | output |
* | --- |
* | "Suspend Storefront" |
*
* @param {Suspend_StorefrontInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const suspend_storefront = /** @type {((inputs?: Suspend_StorefrontInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Suspend_StorefrontInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_suspend_storefront(inputs)
	if (locale === "es") return es_suspend_storefront(inputs)
	if (locale === "fr") return fr_suspend_storefront(inputs)
	if (locale === "de") return de_suspend_storefront(inputs)
	if (locale === "ja") return ja_suspend_storefront(inputs)
	if (locale === "zh") return zh_suspend_storefront(inputs)
	if (locale === "ar") return ar_suspend_storefront(inputs)
	if (locale === "id") return id_suspend_storefront(inputs)
	if (locale === "it") return it_suspend_storefront(inputs)
	if (locale === "ru") return ru_suspend_storefront(inputs)
	if (locale === "pt") return pt_suspend_storefront(inputs)
	return ko_suspend_storefront(inputs)
});